export default "__VITE_ASSET__4Hb9_Ex4__"